import { render } from "./short-biography.vue?vue&type=template&id=16adaf38"
import script from "./short-biography.vue?vue&type=script&lang=js"
export * from "./short-biography.vue?vue&type=script&lang=js"

import "./short-biography.vue?vue&type=style&index=0&id=16adaf38&lang=css"
script.render = render

export default script